import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'role', en);

const UserAssignedListConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Update Role',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.ROLE,
  permission: PERMISSION.UPDATE,
  routes: [
    {
      path: '/role/userAssigned/:roleId',
      component: React.lazy(() => import('./UserAssignedList')),
    },
  ],
};

export default UserAssignedListConfig;
